import { render, staticRenderFns } from "./SubjectFilter.vue?vue&type=template&id=40bcff8a&scoped=true"
import script from "./SubjectFilter.vue?vue&type=script&lang=js"
export * from "./SubjectFilter.vue?vue&type=script&lang=js"
import style0 from "./SubjectFilter.vue?vue&type=style&index=0&id=40bcff8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcff8a",
  null
  
)

export default component.exports